import { render } from "./MiniStatisticsCard.vue?vue&type=template&id=a500dd78"
import script from "./MiniStatisticsCard.vue?vue&type=script&lang=js"
export * from "./MiniStatisticsCard.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__